import React from "react";
import { Typography } from "antd";
import Label from "./Label";
import TemplateThumb from "./TemplateThumb";

const { Text } = Typography;

export default function TemplateSidebar({ templates, templatesLoading, activeTemplateKey, onPickTemplate }) {
  return (
    <div className="no-print" style={{ width: 148, flexShrink: 0, background: "#fff", borderRight: "1px solid #E4E8EE", height: "100%", padding: "16px 10px", boxSizing: "border-box", overflowY: "auto" }}>
      <Label>Templates</Label>
      <TemplateThumb tpl={{ key: "blank", label: "Blank page", elements: [] }} active={activeTemplateKey === "blank"} onClick={() => onPickTemplate("blank")} />
      {templatesLoading ? (
        <Text style={{ fontSize: 11.5, color: "#8A94A3" }}>Loading templates…</Text>
      ) : (
        templates.map((tpl) => <TemplateThumb key={tpl.key} tpl={tpl} active={activeTemplateKey === tpl.key} onClick={() => onPickTemplate(tpl.key)} />)
      )}
    </div>
  );
}
